import { logger } from '../util/logger';
export const loadScript = (source: string): Promise<void> => {
    return new Promise((resolve, reject) => {
        const script = document.createElement("script");
        script.src = source;
        script.addEventListener('load', () => resolve());
        script.addEventListener('error', () => {
            logger.error(`Failed to load JS ${source}`);
            reject(new Error(`Failed to load JS ${source}`));
        });
        document.head.append(script);
    });
};

export const loadCss = (href: string): Promise<void> => {
    return new Promise((resolve, reject) => {
        const link = document.createElement("link");
        link.href = href;
        link.rel = "stylesheet";
        link.addEventListener('load', () => resolve());
        link.addEventListener('error', () => {
            logger.error(`Failed to load CSS ${href}`);
            reject(new Error(`Failed to load CSS ${href}`));
        });
        document.head.append(link);
    });
};
